/**
 * Customer info types for the customer-panel module.
 * Params types use a simplified dispatcher for package-internal use.
 */
import type { Partner } from "@expert/shared-types";

import type { CustomerDetailsPayload } from "../../../../../types";

export interface PhoneNumberGetCustomerDetailsParams {
    searchType: "phoneNumber";
    mdn: string;
    partner: Partner;
    modelResultsMdn?: string;
    sessionId?: string;
    dispatcher?: { dispatchBusinessEvent: (name: string, data?: Record<string, unknown>) => void };
    customerDetailsCallback?: (result: CustomerDetailsPayload) => void;
}

export interface BillingAccountNumberGetCustomerDetailsParams {
    searchType: "billingAccountNumberAndPin";
    billingAccountNumber: string;
    pin?: string;
    partner: Partner;
    modelResultsMdn?: string;
    sessionId?: string;
    dispatcher?: { dispatchBusinessEvent: (name: string, data?: Record<string, unknown>) => void };
    customerDetailsCallback?: (result: CustomerDetailsPayload) => void;
}

export type GetCustomerDetailsParams =
    | PhoneNumberGetCustomerDetailsParams
    | BillingAccountNumberGetCustomerDetailsParams;

/** Re-export ChannelShareData from the store (single source of truth) */
export type { ChannelShareData } from "../../../../../stores/useCallDetailsStore";

// Re-export from useCustomerProgram for convenience
export { useCustomerProgram, type PartnerProgram } from "./useCustomerProgram";
